import incentiveApproachService from "@/views/incentiveApproach/service";
import router from '@/router'
import store from "@/store";

const state = {
    error: false,
    incentiveApproachesLoading: false,
    incentiveApproachList: [],
    selectedCreditor: null,
    filters: {}
}

const mutations = {
    setError(state, error) {
        state.error = error;
    },
    setIncentiveApproachesLoading(state, incentiveApproachesLoading) {
        state.incentiveApproachesLoading = incentiveApproachesLoading;
    },
    setIncentiveApproachList(state, incentiveApproachList) {
        state.incentiveApproachList = incentiveApproachList
    },
    setSelectedCreditor(state, creditor_id) {
        state.selectedCreditor = creditor_id
    },
    saveFilters(state, filters) {
        state.filters = filters;
    }
}

const actions = {
    async getAllIncentiveApproaches({ commit }, params) {
        commit('setError', false);
        commit('setIncentiveApproachesLoading', true);

        const listParams = {
            creditor_id: params.creditor_id,
            limit: 99,
            ...params.pagination,
        }

        await incentiveApproachService.getAllIncentiveApproaches({ ...listParams }).then((data) => {
            commit('setIncentiveApproachList', data.objects)
        }).catch(() => {
            commit('setError', true);
        }).finally(() => {
            commit('setIncentiveApproachesLoading', false);
        })
    },

    async getIncentiveApproach({ commit }, incentive_approach_id) {
        commit('setError', false);
        commit('setIncentiveApproachesLoading', true);

        try {
            const res = await incentiveApproachService.getIncentiveApproach(incentive_approach_id)
            return res
        } catch (error) {
            commit('setError', true);
        } finally {
            commit('setIncentiveApproachesLoading', false);
        }
    },

    async editIncentiveApproach({ state, commit }, incentiveApproach) {
        try {
            const patch = {
                ...incentiveApproach,
                changed_by: store.getters.getLoggedUser.name
            }
            await incentiveApproachService.editIncentiveApproach(patch)
        } catch (error) {
            commit("showSnackbar", error.response.data.error, { root: true });
        }
    },

    async activateOrDeactivateIncentiveApproach({ commit, dispatch }, incentiveApproach) {
        try {
            await incentiveApproachService.editIncentiveApproach({
                id: incentiveApproach.id,
                active: !incentiveApproach.active,
                changed_by: store.getters.getLoggedUser.name
            });
        } catch (error) {
            console.error(error)
            commit("showSnackbar", error.response.data.error, { root: true });
        }
    }
}

const getters = {
    error: (state) => state.error,
    incentiveApproachesLoading: (state) => state.incentiveApproachesLoading,
    incentiveApproachList: (state) => state.incentiveApproachList,
    selectedCreditor: (state) => state.selectedCreditor,
}

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true,
};